* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.section-title {
  color: var(--chart-300-icon-buttons);
}

gz-labeled-content {
  height: 25px;
}

gz-labeled-content:first-of-type {
  margin-bottom: calc(var(--spacer) - 4px);
}

gz-labeled-content::part(content) {
  color: var(--main-titles-inputs-600);
  font-size: var(--body-size);
}
